'use client'

import dynamic from 'next/dynamic'

import { AppProvider } from '../providers/AppProvider/AppProvider'

const Page = dynamic(() => import('../../pages/ProfilePage/ProfilePage'), { ssr: false })

export default function RoutePage() {
  return (
    <AppProvider>
      <Page />
    </AppProvider>
  )
}
